@if (!products) {
  <div class="product-loader">
    <fa-icon [icon]="faEllipsisH" [animation]="'spin'"></fa-icon>
  </div>
}

@if (products && (products | textSearch:'name':productNameSearch).length > 0) {
  <div>
    <div class="list-group">
      <div class="pcategory-name" (click)="togglePcategory()">
        {{ pcategory.delivery_name || pcategory.name }}
      </div>
      <!-- products listing -->
      @if (pcategory.user_hid) {
        <div class="products-list ellipsis" (click)="togglePcategory()">
          <fa-icon [icon]="faEllipsisH" size="4x"></fa-icon>
        </div>
      }
      @for (product of products | textSearch:'name':productNameSearch; track product) {
        <div
          class="list-group-item products-list"
          [class.user-hid]="pcategory.user_hid"
          (click)="selectProduct(product)">
          <div class="product-container">
            <!-- product image -->
            <img loading="lazy" [src]="product.final_mini_picture_path" class="product-image" />
            <!-- product name -->
            <div
              [class.product-title-padding-bottom]="!product.description"
              class="mb-1 product-title">
              {{ product.delivery_name || product.name }}
            </div>
            <!-- product description -->
            <div class="description-container">
              @if (product.description) {
                <span
                  class="mb-1 product-description"
                  [class.clipped-description]="!product.showFullDescription">
                  {{ product.description }}
                </span>
              }
            </div>
            <!-- product price -->
            <span class="product-price">
              @if (pcategory.isPizza) {
                A partir de {{ minPizzaPrice(product).replace('.', ',') }}
              } @else {
                {{ product.price.replace('.', ',') }}
              }
            </span>
          </div>
        </div>
      }
    </div>
  </div>
}